<template>
  <StackLayout class="wrapper">
    <AgWebView v-if="!isWeb" :caption="title" :src="src" height="100%" @close="close" />
    <div v-else class="web-wrapper">
      <div class="header">
        <h2 class="title">{{ title }}</h2>
        <div class="header-controls">
          <span class="navigation-hint" aria-label="Drücken Sie Escape um zu schließen">
            Esc zum Schließen
          </span>
          <AgButton 
            icon="times" 
            iconSize="20" 
            aria-label="Schließen"
            @tap="close" 
            @click="close" 
            ref="closeButton"
          />
        </div>
      </div>
      <WebView :src="src" :title="title" class="content" ref="webview" />
    </div>
  </StackLayout>
</template>

<script>

import { store } from '@/store/index'
import env from '@/helpers/env'
import AgWebView from '@/components/WebView'

export default {
  components: {
    AgWebView
  },
  props: {
    title: String,
    path: String,
    identifier: String,
    externalUrl: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isWeb () {
      return env.isWeb
    },
    src () {
      if (this.externalUrl) {
        return this.path +"?output=embed";
      }

      const params = {
        token: store.state.user.token,
        partnerBirthDate: store.state.user.partner.birth_date,
        ...(this.identifier && { identifier: this.identifier })
      }

      return this.getBaseUrl() + '/' + this.path + '?' + Object.entries(params).map(([key, value]) => key + '=' + value).join('&')
    }
  },
  methods: {
    getBaseUrl () {
      switch (store.state.apiMode) {
        case 'loc':
          return 'http://localhost/'

        case 'dev':
          return process.env.VUE_APP_NEXT_URL_DEV

        case 'stg':
          return process.env.VUE_APP_NEXT_URL_STG

        default:
          return process.env.VUE_APP_NEXT_URL_PRD
      }
    },
    close () {
      this.$emit('done')
    }
  }
}

</script>

<style scoped lang="scss">

.wrapper {
  min-height: 100%;
}

.web-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background-color: #9f9f9f;
    border-bottom: 1px solid #ccc;
    
    .title {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
    
    .header-controls {
      display: flex;
      align-items: center;
      gap: 12px;
      
      .navigation-hint {
        font-size: 12px;
        color: #666;
        font-style: italic;
        white-space: nowrap;
        
        @media (max-width: 768px) {
          display: none;
        }
      }
    }
  }
  
  .content {
    flex: 1;
    border: none;
    width: 100%;
    height: 100%;
  }
}

</style>
